/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Metaindex_Description1Inputs */

const id_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi di egdata.app`)
};

const ms_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi di egdata.app`)
};

const da_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlinger på egdata.app`)
};

const de_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammlungen auf egdata.app`)
};

const en_us2_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections on egdata.app`)
};

const es_es2_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecciones en egdata.app`)
};

const es_mx2_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecciones en egdata.app`)
};

const fil_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Koleksyon sa egdata.app`)
};

const fr_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections sur egdata.app`)
};

const it_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collezioni su egdata.app`)
};

const hu_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyűjtemények az egdata.app-on`)
};

const nl_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collecties op egdata.app`)
};

const no_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlinger på egdata.app`)
};

const pl_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekcje na egdata.app`)
};

const pt_br2_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleções em egdata.app`)
};

const pt_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleções no egdata.app`)
};

const ro_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecții pe egdata.app`)
};

const fi_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokoelmat egdata.appissa`)
};

const sv_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlingar på egdata.app`)
};

const vi_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ sưu tập trên egdata.app`)
};

const tr_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app'teki koleksiyonlar`)
};

const cs_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolekce na egdata.app`)
};

const bg_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекции на egdata.app`)
};

const ru_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подборки на egdata.app`)
};

const uk_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекції на egdata.app`)
};

const ar_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموعات على egdata.app`)
};

const hi_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app पर कलेक्शन`)
};

const th_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คอลเล็กชันบน egdata.app`)
};

const ja_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app のコレクション`)
};

const zh_cn2_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app上的合集`)
};

const zh_hant1_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app上的合集`)
};

const ko_collections_metaindex_description1 = /** @type {(inputs: Collections_Metaindex_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app의 컬렉션`)
};

/**
* | output |
* | --- |
* | "Collections on egdata.app" |
*
* @param {Collections_Metaindex_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_metaindex_description1 = /** @type {((inputs?: Collections_Metaindex_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Metaindex_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_metaindex_description1(inputs)
	if (locale === "ms") return ms_collections_metaindex_description1(inputs)
	if (locale === "da") return da_collections_metaindex_description1(inputs)
	if (locale === "de") return de_collections_metaindex_description1(inputs)
	if (locale === "en-US") return en_us2_collections_metaindex_description1(inputs)
	if (locale === "es-ES") return es_es2_collections_metaindex_description1(inputs)
	if (locale === "es-MX") return es_mx2_collections_metaindex_description1(inputs)
	if (locale === "fil") return fil_collections_metaindex_description1(inputs)
	if (locale === "fr") return fr_collections_metaindex_description1(inputs)
	if (locale === "it") return it_collections_metaindex_description1(inputs)
	if (locale === "hu") return hu_collections_metaindex_description1(inputs)
	if (locale === "nl") return nl_collections_metaindex_description1(inputs)
	if (locale === "no") return no_collections_metaindex_description1(inputs)
	if (locale === "pl") return pl_collections_metaindex_description1(inputs)
	if (locale === "pt-BR") return pt_br2_collections_metaindex_description1(inputs)
	if (locale === "pt") return pt_collections_metaindex_description1(inputs)
	if (locale === "ro") return ro_collections_metaindex_description1(inputs)
	if (locale === "fi") return fi_collections_metaindex_description1(inputs)
	if (locale === "sv") return sv_collections_metaindex_description1(inputs)
	if (locale === "vi") return vi_collections_metaindex_description1(inputs)
	if (locale === "tr") return tr_collections_metaindex_description1(inputs)
	if (locale === "cs") return cs_collections_metaindex_description1(inputs)
	if (locale === "bg") return bg_collections_metaindex_description1(inputs)
	if (locale === "ru") return ru_collections_metaindex_description1(inputs)
	if (locale === "uk") return uk_collections_metaindex_description1(inputs)
	if (locale === "ar") return ar_collections_metaindex_description1(inputs)
	if (locale === "hi") return hi_collections_metaindex_description1(inputs)
	if (locale === "th") return th_collections_metaindex_description1(inputs)
	if (locale === "ja") return ja_collections_metaindex_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_metaindex_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_metaindex_description1(inputs)
	return ko_collections_metaindex_description1(inputs)
});
export { collections_metaindex_description1 as "collections.metaIndex.description" }